import { Globe } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { LANGUAGES, currentLang, setLanguage } from "@/i18n";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const LanguageSwitcher = ({ compact }) => {
  const { user } = useAuth();
  const lang = currentLang();
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const choose = async (code) => {
    if (code === lang) return;
    if (user) {
      try { await api.patch("/auth/me", { language: code }); } catch (e) { console.warn("Could not save language preference to account", e); }
    }
    setLanguage(code);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="language-switcher" aria-label="Change language" title={current.label}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-full border-2 border-slate-200 bg-white font-bold text-sm hover:border-[#1E293B] transition-colors">
          <Globe className="w-4 h-4" /> <span className={compact ? "hidden sm:inline" : ""}>{current.flag} {current.code.toUpperCase()}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-2xl border-2 border-slate-200 p-1.5 min-w-[180px]" data-testid="language-menu">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => choose(l.code)} data-testid={`language-option-${l.code}`}
            className={`rounded-xl font-bold cursor-pointer ${l.code === lang ? "bg-[#FFD166]" : ""}`}>
            <span className="mr-2">{l.flag}</span> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
